"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _LinkGroup = _interopRequireDefault(require("./LinkGroup"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Dependencies

/**
 * Top level of all site links. Renders link groups which render individual links.
 */
class SiteLinks extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      groupLinks: {}
    };
  }

  /**
   * Register the open state of all link groups so they can be passed to all child nodes.
   * @param {string} id the custom id of the individual link group.
   */
  handleLinkGroups(id) {
    let groupLinks = this.state.groupLinks;
    if (!groupLinks[id]) {
      groupLinks[id] = {
        isOpen: false
      };
    }
    for (let i in groupLinks) {
      if (groupLinks[i] !== groupLinks[id]) {
        groupLinks[i].isOpen = false;
      } else {
        if (groupLinks[i] === groupLinks[id] && groupLinks[i].isOpen === true) {
          groupLinks[i].isOpen = false;
        } else {
          groupLinks[i].isOpen = true;
        }
      }
    }
    this.setState({
      groupLinks
    });
  }
  /**
   * Build all the Link Groups.
   */
  buildList() {
    const linkList = this.props.links.slice(0);
    return linkList.map((group, i) => {
      return /*#__PURE__*/_react.default.createElement(_LinkGroup.default, {
        key: i,
        group: group,
        count: i,
        isMobile: this.props.isMobile,
        handleLinkGroups: this.handleLinkGroups.bind(this),
        groupLinks: this.state.groupLinks
      });
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("ul", {
      style: {
        listStyle: 'none',
        padding: 0,
        marginBottom: 0
      },
      className: "site-links-list"
    }, this.buildList(), /*#__PURE__*/_react.default.createElement("div", {
      className: "clearfix"
    }));
  }
}
exports.default = SiteLinks;
SiteLinks.propTypes = {
  links: _propTypes.default.array,
  isMobile: _propTypes.default.bool
};
SiteLinks.defaultProps = {
  links: []
};